import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressComponent } from '@app/components/progress/progress.component';

@Component({
  selector: 'app-loading-container',
  templateUrl: './loading-container.component.html',
  styleUrls: ['./loading-container.component.scss'],
  standalone: true,
  imports: [CommonModule, ProgressComponent]
})
export class LoadingContainerComponent {
  @Input() fullscreen: boolean = false;
  @Input() background: boolean = true;
  @Input() backdropBlur: boolean = true;
  @Input() message?: string;
  @Input() scale: number = 1; // Scale factor for the spinner size (0.5 = 50%, 1 = 100%, 2 = 200%)
}
